import { createPostEndpoint } from '@sonar-software/sonar-http';

export type PostInitiativesSyncJiraRequest = {
	customerId: number;
	initiativeId: number;
	issueKey: string;
};

export const postInitiativesSyncJira = createPostEndpoint<PostInitiativesSyncJiraRequest>(
	({ initiativeId }) => `/api/v3/initiatives/${initiativeId}/sync-jira`,
	{
		requestTransform: ({ initiativeId, ...rest }) => rest
	}
);
